import { EServerPath } from '~/models/api'

const queryKeys = {
  organization: (id: string) => [EServerPath.organization, id],
  trialDaysLeft: (organizationId: string) => [
    EServerPath.trialDaysLeft,
    organizationId,
  ],
  referralUICustomizations: (filters: object = {}) => [
    EServerPath.getRefferalUICustomization,
    filters,
  ],
}

export default queryKeys
